export default __webpack_public_path__ + "static/media/video.ca7d62ea.m4v";